import React, { useState, useEffect, Fragment } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fab, FormControl, Grid, InputLabel, List, ListItem, MenuItem, Select, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import { KeyboardArrowLeftRounded, ExpandMore as ExpandMoreIcon } from '@mui/icons-material'

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import SearchIcon from '@mui/icons-material/Search';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import { uploadDocument } from '../../common/Utils';
//import CircularProgress from '@mui/material/CircularProgress';
import loader from '../../images/loader.gif';
import { authKey, BaseURL } from '../../common/URLs';
import './NewIncident.css';
import { UserContext } from '../../App';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { toast } from 'react-toastify';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Badge from 'react-bootstrap/Badge';
import { FILE_NAME_VALIDATION_ERROR, HELPDESK_ROLES } from '../../common/constants';
import { capitalizeFunction, fileNameValidation, VALIDATION } from '../../common/commonValidations';
import { useTranslation } from 'react-i18next';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { loaderService } from '../../common/custom-loader/loader-service';
import apiClient from '../../axios';

//AUTH KEY
// export const auth = "Bearer " + getLocalStorageItem('id_token');

function NewExternalIncident() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [slaResponse, setSlaResponse] = useState(false);
  const [userDetails, setData] = useState([])
  const [requesttype, SetRequesttype] = useState([]);
  const [faq, setFAQ] = useState('');
  const [expanded, setExpanded] = useState(false);
  const [respData, setRespData] = useState([]);
  const [getCategory, setCategory] = useState("");
  const [getSubCat, setSubCatName] = useState("")
  const [isSubDisbaled, setSubDisabled] = useState(true);
  const [isSubCatSelected, setIsSubCatSelected] = useState(false);
  const [reqDisabled, setReqDisabled] = useState(true);
  const [requesterID, setRequesterID] = useState("")
  const [requesterName, setRequesterName] = useState("")
  const [requesterContact, setRequesterContact] = useState('')
  const [reqTypeVal, setreqTypeVal] = useState("")
  const [satisifedData, setSatisfiedData] = useState('');
  const [requesterEmailId, setrequesterEmailId] = useState('');
  const [errorMessage, setErrorMessage] = useState({

    fileUploadError: ""

  }
  );
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [characterLimit] = useState(500);
  const [saveForm, setSaveForm] = useState();
  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
  const [isApiCalled, setIsApiCalled] = useState(false);

  // FOR MODAL
  const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setGuest(true);
    setOpenModal(false);
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };


  //FORM SUBMIT
  const [Submit, setSubmit] = useState([]);
  const [description, setdescription] = useState('');
  const handleChangedescription = (event) => {
    setdescription(VALIDATION.noSpecialCharacterValidation(capitalizeFunction(event.target.value)));

  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };


  function getDocumentUploadDetails(file) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", file.name);
    formData.append("containerName", "helpdeskfiles");

    apiClient
      .post(
        BaseURL + "/document/v1/Blob/upload_document",
        formData,
        {
          headers: {

            AuthKey: authKey,

          },
        }
      )
      .then((response) => {
        response?.data?.isSuccess === true ? toast.success(response?.data?.message) : toast.error(response?.data?.message);
        // response?.data?.isSuccess === true && 
        if (response?.data?.isSuccess === true) {
          const blobResponse = response?.data?.blobResponse
          const tempArr = {
            "documentName": blobResponse.fileName,
            "documentBlobName": blobResponse.blobFileName,
            //  "ticketOrEmail":
            "isActive": 1,
            "documentContainerName": 'helpdeskfiles',
          };
          //setSelectedFiles(tempArr);
          setSelectedFiles((prevState) => ([...prevState, tempArr]));
        }

      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.message);
        //   loaderService.hideLoader();
      });
  }

  //   ////////////////////////////////////////////
  function handleDocumentChange(e) {
    const choosenFiles = Array.prototype.slice.call(e.target.files)
    let total = 0;
    let pattern = /.*\..*\..*/g;
    choosenFiles.map((file) => {
      total = total + file.size
    })

    if (total > 5000000) {
      toast.error('File size should less than 5MB')
      return false;
      //setErrorMessage({ ...errorMessage, fileUploadError: 'One of the selected file size is more than 5MB, select the files which size less than 5MB' });
    }
    else if (choosenFiles.some(file => pattern.test(file.name.toLowerCase()))) {
      toast.error("Double extension file detected pls select proper file")
      return false;
    }
    else if (choosenFiles.some(file => fileNameValidation(file.name))) {
      toast.error(FILE_NAME_VALIDATION_ERROR)
      return false;
    }
    else if (choosenFiles.every(file => file.type == "image/png" || file.type == "image/jpg"
      || file.type == "image/jpeg" || file.type == "application/pdf")) {
      //   setSelectedFiles(e.target.files);
      //setErrorMessage({ ...errorMessage, fileUploadError: '' });
      choosenFiles.map((file) => {
        getDocumentUploadDetails(file)
      })
    }
    else {
      //  setErrorMessage({ ...errorMessage, fileUploadError: 'Please select the file type jpg,pdf,jpeg ' });
      toast.error('Please select the file type jpg, pdf, jpeg')
      return false;
    }
  };



  function handleDelete(file, index) {
    loaderService.showLoader()
    apiClient.post(
      BaseURL + "/document/v1/Blob/delete_document",
      {
        "fileName": file.documentBlobName,
        "containerName": "helpdeskfiles",
      },
      {
        headers: {

          "Authorization": "Bearer " + getLocalStorageItem('id_token')
        },
      }
    )
      .then((response) => {
        response?.data?.isSuccess === true ? toast.success(response?.data?.message) : toast.error(response?.data?.message);
        const newArr = [...selectedFiles];
        newArr.splice(index, 1);
        setSelectedFiles(newArr)
        loaderService.hideLoader()
      }).catch(function (error) {
        console.log(error);
        toast.error(error.message);
        loaderService.hideLoader();
      });

  }

  const downloadDocument = (file, type) => {
    return fetch(BaseURL + '/document/v1/Blob/download_document'
      ,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          AuthKey: authKey,
        },
        body: JSON.stringify({
          "fileName": file.documentBlobName,
          "containerName": "helpdeskfiles",
          "file": ""
        })
      })
      .then((response) => response.blob()
      )
      .then((blob) => {
        const fileName = file?.documentName
        const splittedName = fileName.split('.')
        const fileExtension = splittedName[splittedName.length - 1];
        let fileType;
        switch (fileExtension) {
          case 'pdf':
            fileType = 'application/pdf';
            break;
          case 'png':
            fileType = 'image/png';
            break;
          case 'jpg':
            fileType = 'image/jpeg';
            break;
          case 'jpeg':
            fileType = 'image/jpeg';
            break;
          default:
            fileType = 'application/octet-stream';
        }
        const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
        const newWindow = window.open(url, '_blank');
        newWindow.focus();
        // loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        // loaderService.hideLoader()
      });
  }

  useEffect(() => {
    if (getCategory && getSubCat) {
      loaderService.showLoader();
      apiClient.post(
        BaseURL + "/grievanceandhelpdesk/v1/helpdesk/updateTicketPriority",
        {
          "category": getCategory,
          "subCategory": getSubCat,
          "extFlag": 1
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          }
        }
      ).then((response) => {
        if (response.data.slafound === false) {
          toast.error("SLA not found for category" + " " + `${getCategory}` + " " + "and sub-category" + " " + `${getSubCat}`)
          setSlaResponse(true)
        }
        else {
          setSlaResponse(false)
        }
        loaderService.hideLoader();
      }).catch((error) => {
        console.log(error);
        loaderService.hideLoader();
      })

    }
  }, [getCategory, getSubCat])

  // ************************************API FOR FORM SUBMIT*********************************

  // SUBMIT FORM 
  function submitclick() {
    if (description == '' || description == null) {
      toast.error('Please Enter Description!')
    }
    else if (description.length > 500) {
      toast.error("Please enter the description within 500 characters");
    } else {
      let newemail = ''
      if (requesterEmailId == '')
        newemail = userDetails.emailId
      else
        newemail = requesterEmailId
      let onSaveForm = {
        "requesterEmailId": newemail,
        "helpdeskGrievanceEnquiryEntity": {
          "urn": userDetails.urn,
          "grievanceCategory": getCategory,
          "grievanceSubCategory": getSubCat,
          "grievanceDescription": description,
          "requestType": reqTypeVal,
          "firstName": userDetails.name?.split(' ')[0],
          "middleName": userDetails.name?.split(' ')[1],
          "lastName": userDetails.name?.split(' ')[2],
          "emailId": userDetails.emailId,
          "mobile": userDetails.mobileNo,
          "crtdBy": userDetails.name,
          "violationFlag": false,
          "sla": 0,
          "requesterContactNo": requesterContact,
          "requesterName": requesterName,
          "requesterId": requesterID,
          "extFlag": 1,
        },
        "helpdeskDocumentMasterEntity":
          selectedFiles
      }
      setSaveForm(onSaveForm)
      handleConfirmLogModalOpen();
    }
  }

  // const onConfirmSubmit = () => {
  //   handleConfirmLogModalClose();
  //   saveOtherUserGrievanceReg();
  // }

  const onConfirmSubmit = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await saveOtherUserGrievanceReg();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setLogConfirmModalOpen(false);
      setIsApiCalled(false);
    }
  };

  const saveOtherUserGrievanceReg = () => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/saveOtherUserGrievanceReg",
      saveForm
      ,
      {
        headers: {
          "Authorization": "Bearer " + getLocalStorageItem('id_token')
        },
      }
    ).then((response) => {
      setSubmit(response.data)
      response.data.status === "SUCCESS" ? toast.success(response.data.description + "Incident ID: " + response.data.responseId) : toast.error(response.data.description)
      navigate('/helpDeskDashboard/requests')
      loaderService.hideLoader();
    }).catch((error) => {
      console.log(error);
      toast.error('Please try again !')
      loaderService.hideLoader();
    })

  }

  // *************Get Value List API*******************
  const fetchRequest = () => {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getValueList",
      {
        "serviceType": "Helpdesk",
        "appKey": "Request_Type"
      },
      {
        headers: {

          "Authorization": "Bearer " + getLocalStorageItem('id_token')
        },
      }
    ).then((response) => {
      SetRequesttype(response.data.filter((item) => item.extFlag === 1))
    }).catch((error) => {
      console.log(error);
    })

  }

  // CALL API ON CLICK ON SATISFIED BUTTON
  const satisfiedBtn = () => {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/isSolvedByFAQ",
      {
        "satisfied": "Satisfied"
      },
      {
        headers: {

          "Authorization": "Bearer " + getLocalStorageItem('id_token')
        },
      }
    ).then((response) => {
      setSatisfiedData(response.data);
      response.data.status === "SUCCESS" ? toast.success(response.data.description) : toast.error(response.data.description)
      navigate('/helpDeskDashboard/requests')
    }).catch((error) => {
      console.log(error);
    })
  }

  const context = React.useContext(UserContext);

  // useEffect(() => {
  //   if (context?.guestUser) {
  //     setrequesterEmailId(context?.guestUser.emailAddress);
  //     setRequesterID(context?.guestUser.emailAddress);
  //     setRequesterName(context?.guestUser.firstname + " " + context.guestUser.lastname);
  //     setRequesterContact(context?.guestUser.mobileNo)
  //   }
  //   console.log(context?.guestUser, "GUEST USER INCIDENT");
  // }, [context.guestUser])

  useEffect(() => {
    fetchRequest();
    fetchCatagory();
    fetchData();
  }, [])

  // Getting Request Type Value
  function handleRequestType(e) {
    setreqTypeVal(e.target.value);
    setCategory("");
    setIsSubCatSelected(false);
    setFaq([]);
    // setSubCatName("")
  }

  //Getting sub-category from category
  function handleCategoryChange(e) {
    setCategory(e.target.value);
    setSubDisabled(false);
    setIsSubCatSelected(false);
    setFaq([]);
    setSubCatName("")
    //setCategory(getCategory) 
  }

  function handleSubCategoryChange(e) {
    setSubCatName(e.target.value);
    setIsSubCatSelected(true);
    showSelectAction(e.target.value)
  }

  const [openModal, setOpenModal] = useState(false)
  function showSelectAction(categoryValue) {
    if (getCategory == "Quality" && categoryValue == "Inspection issue") {
      setOpenModal(true);
      // setCategory('')
      // setSubCatName('')
    }
  }

  const editReq = () => {
    setReqDisabled(false);
    setOpen(true)
  }

  const closeReq = () => {
    if ((requesterContact.length <= 10) && (requesterContact.match('[0-9]{10}'))) {
      setReqDisabled(true);
      setRequesterID(requesterID)
      setRequesterName(requesterName)
      setRequesterContact(requesterContact)

    } else {
      alert('Please provide valid phone number');
    }
  }

  // GET USER DETAILS API **************** 
  const fetchData = () => {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getUserDetails",
      {},
      {
        headers: {
          "Authorization": "Bearer " + getLocalStorageItem('id_token')
        },
      }
    ).then((response) => {
      setData(response.data);
      setRequesterID(response.data.urn || response.data.emailId);
      setRequesterName(response.data.name);
      setRequesterContact(response.data.mobileNo);

      if (context?.guestUser) {
        setrequesterEmailId(context?.guestUser.emailAddress);
        setRequesterID(context?.guestUser.emailAddress);
        setRequesterName(context?.guestUser.firstname + " " + context?.guestUser.lastname);
        setRequesterContact(context?.guestUser.mobileNo);
        context.addGuestUser(null)
      }
    }).catch((error) => {
      console.log(error);
    })

  }

  //fetchCategoryAndSubcategory API
  const fetchCatagory = () => {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchCategoryAndSubcategory",
      {},
      {
        headers: {
          "Authorization": "Bearer " + getLocalStorageItem('id_token'),
          "extFlag": true,
        },
      }
    ).then((response) => {
      // console.log("Success - ", response);
      setRespData(response.data);
      // console.log(respData, "responseData");

    }).catch((error) => {
      console.log("Error - " + error);
    })
  }


  // getFAQAnswerbySubcategory API
  useEffect(() => {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getFAQAnswerbySubcategory",
      {
        "grievanceCategory": getCategory,
        "grevanceSubCategory": getSubCat,
        "extFlag": 1,
      },
      {
        headers: {
          "Authorization": "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      setFaq(response.data);
    }).catch((error) => {
      console.log("Error -" + error);

    })
  }, [getSubCat]);

  const [getFaq, setFaq] = useState([])
  const helpTopics = [...getFaq];
  const [reqUrn, setReqUrn] = useState('')
  //FETCH USER DETAIL BY URN NUMBER
  const handleUrn = (event) => {
    setReqUrn(event.target.value);
  }
  const [reqCont, setReqCont] = useState('')
  const handleContact = (event) => {
    setReqCont(event.target.value)
  }

  const [guestContct, setGetContct] = useState("")
  const handleGuestContact = (event) => {
    setGetContct(event.target.value)
  }

  const [guest, setGuest] = useState(true)
  //UPDATE URN NUMBER IN MODAL
  const updateUrn = () => {
    apiClient.post(
      BaseURL + "/registration/v1/User/get_user",
      {
        "emailAddress": reqUrn ? reqUrn : "",
      },
      {
        headers: {
          "Authorization": "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      if (response.data.user === null) {
        alert("Please Enter Valid Email");
        setGuest(false);
      } else {
        let displayName = [response.data.user.firstname, response.data.user.middlename, response.data.user.lastname]
        setrequesterEmailId(response.data.user.emailAddress);
        setRequesterID(response.data.user.emailAddress);
        setRequesterName(displayName?.filter(part => part).join(' '));
        setRequesterContact(response.data.user.mobileNo);
        setReqDisabled(true)
        setOpen(false);
        toast.success("Requester Details Added")
      }
    }).catch((error) => {
      console.log(error, "ErrorMsg");
    })
  }

  const updateContact = () => {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchUserDetailByMobileNumber",
      {
        "mobileNumber": reqCont
      },
      {
        headers: {
          "Authorization": "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      if (response.data.stakeHolder == null) {
        alert("Please Enter Valid Contact Number")
        setGuest(false);
      } else {
        setrequesterEmailId(response.data.stakeHolder.emailId);
        setRequesterID(response.data.stakeHolder.urn || response.data.stakeHolder.emailId);
        setRequesterName(response.data.stakeHolder.name);
        setRequesterContact(response.data.stakeHolder.mobileNo);
        setReqDisabled(true)
        setOpen(false);
        toast.success("Requester Details Added")
      }
    }).catch((error) => {
      console.log(error, "ErrorMsg");
    })
  }
  const updateData = () => {
    apiClient.post(
      BaseURL + "/registration/v1/User/get_user",
      {
        // "urn": reqUrn
        "mobileNumber": reqCont ? reqCont : "",
        "emailAddress": reqUrn ? reqUrn : "",

      },
      {
        headers: {
          "Authorization": "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      // if (response.data.stakeHolder == null) {
      //   alert("Please Enter Valid URN");
      //   setGuest(false);
      // } else {
      setrequesterEmailId(response.data.user.emailAddress);
      setRequesterID(response.data.user.emailAddress);
      setRequesterName(response.data.user.firstname + " " + response.data.user.middlename + " " + response.data.user.lastname);
      setRequesterContact(response.data.user.mobileNo);
      setReqDisabled(true)
      setOpen(false);
      toast.success("Requester Details Added")
      // }
    }).catch((error) => {
      console.log(error, "ErrorMsg");
    })
  }

  const updateGuestContact = () => {
    apiClient.post(
      BaseURL + "/registration/v1/User/get_user",
      {
        "mobileNumber": guestContct
      },
      {
        headers: {
          "Authorization": "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      if (response.data.user == null) {
        alert("Please Enter Valid Contact Number")
        setGuest(false);
      } else {
        if (response.data.user.userRoles.roleName == "GHD-GuestUser") {
          setrequesterEmailId(response.data.user.emailAddress);
          setRequesterID(response.data.user.emailAddress);
          setRequesterName(response.data.user.firstname + " " + response.data.user.lastname);
          setRequesterContact(response.data.user.mobileNo);
          setReqDisabled(true)
          setOpen(false);
          toast.success("Guest Requester Details Added")
        }
      }
    }).catch((error) => {
      console.log(error, "ErrorMsg");
    })
  }

  const guestUser = () => {
    // window.location.replace('https://apps-dev.abrpl.co.in/?param=GuestUser');
    navigate(`/GuestUserSignUp?redirectTo=new-incident`);

    setReqDisabled(false)
    setOpen(false);
    setGuest(true)
  }

  const [showContactBox, setShowContactBox] = useState()
  const showContact = () => {
    setShowContactBox(!showContactBox);
    setGuestShowContactBox(false)
  }

  const [showGuestContactBox, setGuestShowContactBox] = useState()
  const showGuestContact = () => {
    setGuestShowContactBox(!showGuestContactBox);
    setShowContactBox(false)
  }

  const categoryList = respData?.External_category

  return (
    <>
      <Helmet>
        <title> New External Incident | ABEPL </title>
      </Helmet>
      {/* {(isLoading) ?
        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
          <img src={loader} alt="loading..." />
        </div> */}
      :
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 2 }}>
          <Fab component={RouterLink} to='../requests' size="small" aria-label="back" title='Back'>
            <KeyboardArrowLeftRounded />
          </Fab> {t('helpdesk.newExternalIncident')}
        </Typography>
        {/* <Typography>{context.guestUser.data}</Typography> */}
        <Card>
          <Stack spacing={2} sx={{ m: 2 }}>
            <Grid container>
              <Grid item xs={12}>
                <Card>
                  <Table aria-label="simple table" size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">{t('helpdesk.userId')}</TableCell>
                        <TableCell align="left">{t('helpdesk.userName')}</TableCell>
                        <TableCell align="left">{t('helpdesk.contactNo')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell align="left">{userDetails?.urn || userDetails?.emailId || "abrpldev@outlook.com"}</TableCell>
                        <TableCell align="left">{userDetails?.name ?? "Alex Furguson"}</TableCell>
                        <TableCell align="left">{userDetails?.mobileNo}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Card>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Card>
                  <Table aria-label="simple table" size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ width: '37%' }} align="left">{t('helpdesk.requesterUrnEmail')}</TableCell>
                        <TableCell sx={{ width: '35%' }} align="left">{t('helpdesk.requesterName')}</TableCell>
                        <TableCell sx={{ width: '15%' }} align="left">{t('helpdesk.contactNo')}</TableCell>
                        <TableCell sx={{ width: '13%' }} align='left'>{t('helpdesk.edit')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell align="left">
                          <FormControl fullWidth size='small'>
                            <TextField inputProps={{ style: { fontSize: '14px' } }} id="standard-basic" variant="standard" sx={{ padding: 0 }} defaultValue={requesterID} value={requesterID} disabled={reqDisabled} onInput={e => setRequesterID(e.target.value)} />
                          </FormControl>
                        </TableCell>
                        <TableCell align="left">
                          <FormControl fullWidth size='small'>
                            <TextField inputProps={{ style: { fontSize: '14px' } }} id="standard-basic" variant="standard" sx={{ padding: 0 }} defaultValue={requesterName} value={requesterName} disabled={reqDisabled} onInput={e => setRequesterName(e.target.value)} />
                          </FormControl>
                        </TableCell>
                        <TableCell align="left">
                          <FormControl fullWidth size='small'>
                            <TextField inputProps={{ style: { fontSize: '14px' } }} id="standard-basic" variant="standard" sx={{ padding: 0 }} defaultValue={requesterContact} value={requesterContact} disabled={reqDisabled} onInput={e => setRequesterContact(e.target.value)} />
                          </FormControl>
                        </TableCell>
                        <TableCell align="left">
                          <Tooltip title="Edit">
                            <IconButton color='primary' onClick={() => editReq()} sx={{ mr: 2 }}><EditIcon fontSize='small'></EditIcon></IconButton></Tooltip>
                          {(reqDisabled === false) ?
                            <Tooltip title="Save">
                              <IconButton color='primary' variant="contained" size="small" onClick={() => closeReq()} ><SaveAltIcon fontSize='small'></SaveAltIcon ></IconButton></Tooltip>
                            : null}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Card>
              </Grid>
            </Grid>

            {/* MODAL FOR REQUESTER CHANGE */}
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open}>
                <Box sx={style}>
                  <Typography id="transition-modal-title" variant="h6" component="h2" sx={{ marginBottom: '10px' }}>
                    {t('helpdesk.updateRequesterDetails')}
                  </Typography>
                  <Box className='editBox' style={{ width: "100%" }}>
                    <TextField id="outlined-basic" label={t('helpdesk.addRequesterEmail')} variant="standard" onChange={handleUrn} style={{ width: "100%" }} />
                  </Box>
                  <div className='w-100 float-end'>
                    <Button variant="contained" size="default" sx={{ width: '100%', marginTop: '10px', marginBottom: '10px' }} onClick={() => updateUrn()} ><SearchIcon fontSize='small'></SearchIcon > {t('helpdesk.searchByEmail')} </Button>
                  </div>
                  <p className='or'> {t('helpdesk.or')} </p>

                  <div className='w-100 float-end' style={{ marginTop: '10px' }}>
                    <Typography variant='h6' color={"#08539d"} style={{ fontSize: "16px !important" }}>
                      {t('helpdesk.searchByContact')}-
                    </Typography>
                    {/* <Button variant="contained" size="default" sx={{ width: '48%', marginRight: '10px', marginBottom: '10px' }} onClick={() => showContact()}><SearchIcon fontSize='small'></SearchIcon > {t('helpdesk.stakeholder')} </Button>
                      <Button variant="contained" size="default" sx={{ width: '48%', marginBottom: '10px' }} onClick={() => showGuestContact()}><SearchIcon fontSize='small'></SearchIcon > {t('helpdesk.guest')} </Button> */}
                  </div>
                  <>
                    <Box className='editBox' style={{ marginTop: '0px !important', width: "100%" }}>
                      {/* <Typography variant='h6'>
                            Search by Contact Number
                          </Typography> */}
                      <TextField id="outlined-basic" label={t('helpdesk.addRequesterContact')} variant="standard" onChange={handleContact} style={{ width: "100%" }} />
                    </Box>
                    <div className='w-100 float-end'>
                      <Button variant="contained" size="default" sx={{ width: '100%', marginTop: '10px', marginBottom: '10px' }} onClick={() => updateData()} ><SearchIcon fontSize='small'></SearchIcon > {t('helpdesk.searchByContact')} </Button>
                    </div>
                  </>

                  {showContactBox === true ?
                    <>
                      <Box className='editBox' style={{ marginTop: '0px !important', width: "100%" }}>
                        {/* <Typography variant='h6'>
                            Search by Contact Number
                          </Typography> */}
                        <TextField id="outlined-basic" label={t('helpdesk.addRequesterContact')} variant="standard" onChange={handleContact} style={{ width: "100%" }} />
                      </Box>
                      <div className='w-100 float-end'>
                        <Button variant="contained" size="default" sx={{ width: '100%', marginTop: '10px', marginBottom: '10px' }} onClick={() => updateContact()} ><SearchIcon fontSize='small'></SearchIcon > {t('helpdesk.searchByContact')} </Button>
                      </div>
                    </>
                    : ""}

                  {showGuestContactBox === true ?
                    <>
                      <Box className='editBox' style={{ marginTop: '0px !important', width: "100%" }}>
                        {/* <Typography variant='h6'>
                            Search by Guest Contact Number
                          </Typography> */}
                        <TextField id="outlined-basic" label={t('helpdesk.addGuestContact')} variant="standard" onChange={handleGuestContact} style={{ width: "100%" }} />
                      </Box>
                      <div className='w-100 float-end'>
                        <Button variant="contained" size="default" sx={{ width: '100%', marginTop: '10px', marginBottom: '10px' }} onClick={() => updateGuestContact()} ><SearchIcon fontSize='small'></SearchIcon > {t('helpdesk.searchByGuestContact')} </Button>
                      </div>
                    </>
                    : ""}

                  <Typography hidden={guest}>
                    <p
                      onClick={() => guestUser()}
                    >
                      {t('helpdesk.dontHaveValidDetails')} <b style={{ 'cursor': 'pointer', 'font-size': '14px', 'color': '#003f82', 'fontStyle': 'italic' }}> {t('helpdesk.applyAsNewGuest')}. </b></p>
                  </Typography>

                </Box>
              </Fade>
            </Modal>
            {/* MODAL FOR REQUESTER CHANGE ENDS*/}

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
              <FormControl fullWidth size="small">
                <InputLabel id="select-requestType-label">{t('helpdesk.requestType')}</InputLabel>
                <Select
                  labelId="select-requestType-label"
                  id="select-requestType"
                  label={t('helpdesk.requestType')}
                  defaultValue={""}
                  // value={requestType}
                  onChange={handleRequestType}
                >
                  <MenuItem value="">
                    <em>{t('helpdesk.select')}</em>
                  </MenuItem>
                  {
                    requesttype.map(function (object, i) {
                      return <MenuItem value={object.value} key={object.value}>{object.value}</MenuItem>
                    })
                  }
                </Select>
              </FormControl>
              <FormControl fullWidth size="small">
                <InputLabel id="select-category-label">{t('helpdesk.category')}</InputLabel>
                <Select
                  labelId="select-category-label"
                  id="select-category"
                  label={t('helpdesk.category')}
                  defaultValue={getCategory}
                  value={getCategory}
                  onChange={handleCategoryChange}
                //onClick={() => fetchCategory()}
                >
                  <MenuItem value="">
                    <em>{t('helpdesk.select')}</em>
                  </MenuItem>
                  {categoryList?.map(function (categoryList, i) {
                    return <MenuItem key={categoryList} value={categoryList}>{categoryList}</MenuItem>
                  })}
                  {/* <MenuItem value={1}>Registration</MenuItem> */}
                </Select>
              </FormControl>

              <FormControl fullWidth size="small" disabled={isSubDisbaled}>
                <InputLabel id="select-subCategory-label">{t('helpdesk.subCategory')}</InputLabel>
                <Select
                  labelId="select-subCategory-label"
                  id="select-subCategory"
                  label={t('helpdesk.subCategory')}
                  defaultValue={getSubCat}
                  value={getSubCat}
                  onChange={handleSubCategoryChange}
                >
                  <MenuItem value="">
                    <em>{t('helpdesk.select')}</em>
                  </MenuItem>
                  {respData && respData[`${getCategory}`]?.map(function (subcat, i) {
                    return <MenuItem key={subcat} value={subcat}>
                      {subcat}</MenuItem>
                  })}
                </Select>
              </FormControl>
            </Stack>

            {/* //SHOW MODAL for QUALITY & INSPECTION  */}
            <Dialog
              open={openModal}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                You have selected Quality and Inspection Issue
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Please mention Consignment ID/ Bundle Id for which there is an quality issue and inspection is required
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Close</Button>
              </DialogActions>
            </Dialog>


            <Grid container>
              <Grid item xs={12} sx={{ pt: 1 }}>
                {helpTopics && helpTopics.length == 0 && isSubCatSelected ?
                  <Typography variant='subtitle2' sx={{ color: 'text.secondary' }} align='center'>
                    {t('helpdesk.noFaqFound')}
                  </Typography>
                  :
                  helpTopics && helpTopics.length > 0 && <Typography variant='subtitle2' sx={{ color: 'text.secondary' }} align='center'>
                    {t('helpdesk.helpTopics')}
                  </Typography>}
                {helpTopics?.map((topicAns, index) => {
                  let idx = index + 1;
                  return (
                    <Fragment>
                      <Accordion key={`accordion${idx}`} disableGutters expanded={expanded === `panel${idx}`} onChange={handleChange(`panel${idx}`)}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls={`panel${idx}a-content`}
                          id={`panel${idx}a-header`}
                          sx={{ backgroundColor: 'rgba(0, 0, 0, .03)', }}
                        >
                          <Typography>#{idx} {topicAns.fqaQuestion} </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ borderTop: '1px solid rgba(0, 0, 0, .125)', }}>
                          <Typography>
                            {topicAns.fqaAnswer}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </Fragment>
                  )
                })}

                {helpTopics?.length > 0 ?
                  <Typography component={'span'} sx={{ mt: 2, mr: 2, display: 'flex', justifyContent: 'end', alignItems: 'end' }} variant='body2' align='right'>

                    <Button sx={{ textTransform: 'none', mr: 2, borderRadius: 0.5 }} size="medium" variant="contained" color="success" onClick={satisfiedBtn}>{t('helpdesk.satisfied')}</Button>
                    <Box sx={{ gap: 2 }} >
                      <Box sx={{ color: 'text.secondary' }}>{t('helpdesk.stillNotSatisfied')}</Box>
                      <Button variant="contained" color="primary" sx={{ textTransform: 'none', borderRadius: 0.5 }} size="medium" disabled={slaResponse} onClick={() => setFAQ('other')}>
                        {t('helpdesk.createTicket')}
                      </Button>
                    </Box>
                  </Typography>
                  :
                  getCategory && getSubCat && (faq !== 'other') ?
                    <Box component={'span'} sx={{ mt: 2, mr: 2, display: 'flex', justifyContent: 'end', alignItems: 'end', gap: 2 }} variant='body2' align='right' >
                      <Button variant="contained" color="primary" sx={{ textTransform: 'none', borderRadius: 0.5 }} size="medium" disabled={slaResponse} onClick={() => setFAQ('other')}>
                        {t('helpdesk.createTicket')}
                      </Button>
                    </Box>
                    :
                    <></>
                }
                {/* {helpTopics?.length > 0 ?
                    <Typography component={'span'} sx={{ mt: 2, mr: 2, display: 'flex', justifyContent: 'end', alignItems: 'end' }} variant='body2' align='right'>

                      <Button sx={{ textTransform: 'none', mr: 2, borderRadius: 0.5 }} size="medium" variant="contained" color="success" onClick={satisfiedBtn}>{t('helpdesk.satisfied')}</Button>
                      <Box sx={{ gap: 2 }} >
                        <Box sx={{ color: 'text.secondary' }}>{t('helpdesk.stillNotSatisfied')}</Box>
                        <Button variant="contained" color="primary" sx={{ textTransform: 'none', borderRadius: 0.5 }} size="medium" onClick={() => setFAQ('other')}>
                          {t('helpdesk.createTicket')}
                        </Button>
                      </Box>
                    </Typography>
                    :
                    <></>
                  } */}

                {/* <Typography component={'span'} sx={{ mt: 2, mr: 2, display: 'flex', justifyContent: 'end', alignItems: 'end' }} variant='body2' align='right'>

                    <Button sx={{ textTransform: 'none', mr: 2, borderRadius: 0.5 }} size="medium" variant="contained" color="success" onClick={satisfiedBtn}>Satisfied</Button>
                    <Box sx={{ gap: 2 }} >
                      <Box sx={{ color: 'text.secondary' }}>Still not satisfied?</Box>
                      <Button variant="contained" color="primary" sx={{ textTransform: 'none', borderRadius: 0.5 }} size="medium" onClick={() => setFAQ('other')}>
                        Create a ticket
                      </Button>
                    </Box>
                  </Typography> */}


                {(faq === 'other') && <>
                  <Grid container>
                    <Grid item xs={12} md={6} mt={1}>
                      <TextField fullWidth
                        autoComplete="off"
                        id="outlined-multiline-static"
                        label={t('helpdesk.description')}
                        multiline
                        rows={4}
                        onChange={handleChangedescription}
                        value={description}

                        sx={{ paddingRight: '15%' }}
                      />
                      <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '10%' }}>
                        <Badge bg={`${description.length > characterLimit ? 'danger' : 'primary'}`}>{description.length}/{characterLimit}</Badge>
                      </div>
                    </Grid>

                  </Grid>


                  <Box sx={{ marginRight: '35%', }}>

                    {/* <Box component="outlined" sx={{  borderRadius: '16px', border: '2px dashed ', borderColor: 'secondary.main' }}> */}
                    <Grid container spacing={3}

                      justifyContent="center"
                      alignItems="center">
                      <Grid item xs={12} sm={6} md={6}>
                        <Card style={{ backgroundColor: "rgb(243,247,244)" }}>

                          <Stack direction="column"
                            justifyContent="center"
                            alignItems="center"
                            style={{ padding: "3%" }}>
                            <label style={{ fontSize: '18px', fontWeight: 'bold' }} >{t('helpdesk.uploadYourFileHere')}</label>
                            <IconButton disabled color="secondary" >
                              <CloudUploadIcon color="warning"
                                fontSize="large"
                              />
                            </IconButton>
                            <Button variant="contained" component="label">{t('helpdesk.browse')}
                              <input id='fileUpload' type="file" multiple
                                onChange={(e) => { handleDocumentChange(e); e.target.value = null }}
                                //  accept='application/pdf, image/png'
                                //  disabled={fileLimit}
                                placeholder="Upload"
                                style={{ display: "none" }}
                              />
                            </Button>
                            <label style={{ fontSize: '10px' }}>{t('helpdesk.supportedFile')}</label>
                            {/* </Box> */}
                          </Stack>
                        </Card>
                      </Grid>

                      <Grid item xs={12} sm={6} md={6}>

                        {selectedFiles.map((file, index) => (
                          <Stack direction="row">
                            📁
                            &nbsp;
                            <Typography color="neutral" > {file?.documentName}
                              &nbsp;
                              &nbsp;

                              <RemoveRedEyeIcon color="primary" onClick={() => downloadDocument(file, "Create")} variant="outlined" size="sm" />

                            </Typography>
                            <DeleteIcon onClick={() => handleDelete(file, index)} />
                            {/* <DeleteIcon color="error" fontSize="small" sx={{ mt: 0.5 }}   /> */}
                          </Stack>
                        ))
                        }
                      </Grid>
                    </Grid>
                  </Box>
                  <Box display='flex' alignItems="center" justifyContent="center" mt={1}>
                    <Button onClick={() => setFAQ('')} sx={{ minWidth: 120, mr: 2 }} variant="outlined">{t('reg.cancel')}</Button>
                    <Button sx={{ minWidth: 120 }} variant="contained"
                      onClick={() => { submitclick() }}>{t('preReg.submit')}</Button>
                  </Box>
                </>}


              </Grid>
            </Grid>
          </Stack>
        </Card>
        <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmSubmit} onClose={handleConfirmLogModalClose} action="Submit" />
      </Container>
      {/* // } */}
    </>
  )
}
export default NewExternalIncident
